"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when a request returns Forbidden
 * on operation for externally managed class
 * @param {string} classId the class id
 * @param {object} meta additional meta data related to the error
 */
class ForbiddenForManagedClass extends client_library_1.ExtendableError {
    constructor(classId, meta) {
        super(`Forbidden operation for externally managed class: ${classId}`);
        this.classId = classId;
        this.meta = meta;
    }
}
exports.default = ForbiddenForManagedClass;
//# sourceMappingURL=ForbiddenForManagedClass.js.map